import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LiveClassAll.css";
import { IoInformationCircleOutline } from "react-icons/io5";

const LiveClassAll = () => {
  const navigate = useNavigate();
  const [liveClassesAll, setLiveClassesAll] = useState([]);
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/live-classes`)
      .then((response) => {
        console.log(response.data?.data);
        const data = response.data?.data;
        setLiveClassesAll(data);
      })
      .catch((error) => console.log(error));
  }, [API_BASE_URL]);

  const handleEdit = (id) => {
    navigate(`/live-class-edit/${id}`);
  };
  const handleLiveClassDlt = async (id) => {
    let dltOrNot = window.confirm("Do you want to delete");
    if (dltOrNot) {
      try {
        await axios.delete(`${API_BASE_URL}/admin/live-classes/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        alert("Live class deleted successfully!");
        // Remove the deleted item from the state
        setLiveClassesAll(
          liveClassesAll.filter((liveClass) => liveClass._id !== id)
        );
      } catch (error) {
        console.error("Failed to delete live class:", error);
      }
    }
  };

  return (
    <div id="add-subject-inner-wrapper">
      <div className="superheader">
        <div className="subjectHeaderdiv">
          <h5>Live Classes</h5>
          <div className="subjectdiv2">
            <button
              className="handleNewSubject"
              onClick={() => navigate("/live-class-add")}
            >
              + Add New Live Class
            </button>
            <button
              className="allSubjects"
              onClick={() => navigate("/live-class-list")}
            >
              All Live Class
            </button>
          </div>
        </div>

        <div className="form-sub-container mt-4" id="form">
          <h4 className="subject-detail">All Live Class List</h4>
          <table className="classes-table">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Title</th>
                <th>Description</th>
                <th>Teacher names</th>
                <th>Price</th>
                <th>Thumbnail</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {liveClassesAll.map((liveClass, idx) => (
                <tr key={liveClass._id}>
                  <td>{idx + 1}</td>
                  <td>{liveClass.title}</td>
                  <td>{liveClass.description.slice(0,40)}...</td>
                  <td>
                    {liveClass.teacherName.map((teacher, idx) => (
                      <p key={idx}>{teacher}</p>
                    ))}
                  </td>
                  <td>{liveClass.price}</td>
                  <td>
                    <img
                      src={`${API_BASE_URL}/uploads/${liveClass.thumbnail}`}
                      alt=""
                      className="liveClassImg"
                    />
                  </td>
                  <td className="table-action-icons">
                    <i
                      className="fa-solid fa-file-pen"
                      onClick={() => handleEdit(liveClass._id)}
                    ></i>
                    <i
                      className="fa-solid fa-trash-can"
                      onClick={() => handleLiveClassDlt(liveClass._id)}
                    ></i>
                    <span
                      className="live-class-detail-icon"
                      onClick={() =>
                        navigate(`/live-class-detail/${liveClass._id}`)
                      }
                    >
                      <IoInformationCircleOutline />
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default LiveClassAll;
